import { useTheme } from '@mui/material';
import { memo } from 'react';
import { useOrderProductsLayoutContext } from '../../../../../../../../contexts/OrderProductsLayout.context';
import useOrderProductGridContext from '../../../../../contexts/OrderProductGrid.context';
import { getGridSpacing } from '../../../../components/HorizontalScroll/HorizontalScroll.styles';
import ProductInput from '../../../../productInput/components/ProductInput';

const OrderProductGrid = () => {
  const theme = useTheme();
  const { grid, suggestedGrid } = useOrderProductGridContext();
  const { hasTouchGrid } = useOrderProductsLayoutContext();
  const columnGap = `${getGridSpacing(hasTouchGrid)}px`;

  return (
    <div style={{ display: 'flex', columnGap, width: '100%', paddingRight: theme.spacing(0.5) }}>
      {grid?.map((gridItem) => (
        <ProductInput
          key={`${gridItem.productSizeId}-${gridItem.skuId}`}
          gridItem={gridItem}
          suggestedGridItem={suggestedGrid.find(
            (suggestedItem) => suggestedItem.skuId === gridItem.skuId,
          )}
        />
      ))}
    </div>
  );
};

export default memo(OrderProductGrid);
